<template>
  <div class="programme">
    <h3>Instructions</h3>
    <div class="instructions">
      <ul>
        <li>
          Download the
          <a
            href="https://firebasestorage.googleapis.com/v0/b/bsda-87db2.appspot.com/o/AppTemplate.pub?alt=media&token=e0af8700-9229-40f2-8e72-b672418959c9"
          >publisher template (here)</a>
          if you do not already have it and do the neccessary edits.
          The pdf used by the app has specific dimensions. This template has the recommended dimensions.
        </li>
        <li>When finished editing, convert the publisher file to pdf.</li>
        <li>Upload the pdf programme and click submit.</li>
      </ul>
      OR upload any pdf
    </div>
    <div class="upload-div">
      <label>
        <input type="file" id="file" ref="file" @change="handleFileUpload()" />
      </label>
      <br />
      <button class="btn btn-primary submit" :disabled="!file || submitted" @click="submitFile()">
        Submit
        <font-awesome-icon icon="circle-notch" class="fa-spin" v-if="submitted"></font-awesome-icon>
      </button>
      <div class="col-12 alert alert-danger" v-if="error">{{error}}</div>
      <div class="col-12 alert alert-success" v-if="success">{{success}}</div>
    </div>
  </div>
</template>
<script>
import { storeFile, getProgramme, setProgramme } from "../db.js";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "Programme",
  components: {
    FontAwesomeIcon
  },
  data() {
    return {
      programme: {},
      submitted: false,
      success: "",
      error: "",
      file: null,
      progress: 0,
      downloadUrl: ""
    };
  },
  async created() {
    const result = await getProgramme();
    this.programme = result.val();
  },
  methods: {
    saveProgrammeLink(url) {
      setProgramme({
        url,
        version: this.programme.version + 1
      })
        .then(() => {
          this.submitted = false;
          this.success = "Programme uploaded succesfully";
          this.resetMessage();
        })
        .catch(err => {
          this.submitted = false;
          this.error = "An error occured uploading the file.";
          this.resetMessage();
        });
    },
    handleFileUpload() {
      this.error = "";
      this.success = "";
      this.file = this.$refs.file.files[0];
    },
    submitFile() {
      this.submitted = true;
      let uploadTask = storeFile(this.file);

      uploadTask.on(
        "state_changed",
        snapshot => {
          this.progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        error => {
          // Handle unsuccessful uploads
          this.submitted = false;
          this.error = "An error occured uploading the file.";
        },
        () => {
          // Handle successful uploads on complete
          uploadTask.snapshot.ref
            .getDownloadURL()
            .then(downloadURL => {
              this.downloadUrl = downloadURL;
              this.saveProgrammeLink(downloadURL);
            })
            .catch(err => {
              this.submitted = false;
              this.error = "An error occured uploading the file.";
            });
        }
      );
    },
    resetMessage() {
      setTimeout(() => {
        this.success = "";
        this.error = "";
      }, 5000)
    }
  }
};
</script>
<style lang="scss" scoped>
.upload-div {
  margin: 50px 0;
}
.submit {
  margin: 25px 0;
}
</style>